import { request as umiRequest } from "@umijs/max";
import type { RequestOptions } from "@@/plugin-request/request";
import { BizAppConfig } from "config/application.manifest";

type ScopedRequestOptions = RequestOptions;

export const createRequest = (baseURL?: string) => {
  const scopedBaseURL = baseURL ?? BizAppConfig.appApiUrl ?? "";
  return async <T = unknown>(
    url: string,
    options?: ScopedRequestOptions
  ): Promise<T> => {
    const result = await (
      umiRequest as unknown as <R = unknown>(
        requestUrl: string,
        requestOptions?: ScopedRequestOptions
      ) => Promise<R>
    )<T>(url, {
      baseURL: scopedBaseURL,
      ...(options || {}),
    });
    if (!url.includes("/bff")) return result;
    const response = result as unknown as {
      code?: number;
      msg?: string;
      data?: T;
    };
    if (typeof response.code !== "number" || !("data" in response))
      return result;
    if (response.code !== 200) {
      const error = new Error(response.msg || "请求失败") as Error & {
        info?: unknown;
      };
      error.name = "BizError";
      error.info = {
        errorCode: response.code,
        errorMessage: response.msg,
        data: response.data,
      };
      throw error;
    }
    return response.data as T;
  };
};

export const createAppRequest = () => createRequest(BizAppConfig.appApiUrl);
export const createTenantManagementRequest = () =>
  createRequest(BizAppConfig.appTenantManagementUrl);
